import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=238bcc1c&scoped=true&"
import script from "./Contact.vue?vue&type=script&lang=js&"
export * from "./Contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238bcc1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('238bcc1c')) {
      api.createRecord('238bcc1c', component.options)
    } else {
      api.reload('238bcc1c', component.options)
    }
    module.hot.accept("./Contact.vue?vue&type=template&id=238bcc1c&scoped=true&", function () {
      api.rerender('238bcc1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Setting/Contact.vue"
export default component.exports